'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _durationToSecs = require('../duration/durationToSecs');

var _durationToSecs2 = _interopRequireDefault(_durationToSecs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (duration, unit) {
    return (0, _durationToSecs2.default)(duration, unit) < 60 * 60 * 24;
};